import { render, staticRenderFns } from "./search.vue?vue&type=template&id=64641c7c&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=64641c7c&prod&scoped=true&lang=css"
import style1 from "./search.vue?vue&type=style&index=1&id=64641c7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64641c7c",
  null
  
)

export default component.exports